import { render, staticRenderFns } from "./EventPlayoutLayout.vue?vue&type=template&id=06aa6efb&scoped=true&"
import script from "./EventPlayoutLayout.vue?vue&type=script&lang=js&"
export * from "./EventPlayoutLayout.vue?vue&type=script&lang=js&"
import style0 from "./EventPlayoutLayout.vue?vue&type=style&index=0&id=06aa6efb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aa6efb",
  null
  
)

export default component.exports